import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router)

export default new Router({
  
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
        {
          path: '/icons',
          name: 'icons',
          component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue')
        },
        {
          path: '/maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue')
        },
        {
          path: '/washing-machine',
          name: 'washing machine',
          component: () => import(/* webpackChunkName: "demo" */ './views/WashingMachine.vue')
        },
        {
          path: '/deposit',
          name: 'deposit',
          component: () => import(/* webpackChunkName: "demo" */ './views/Deposit.vue')
        },
        {
          path: '/withdraw',
          name: 'withdraw',
          component: () => import(/* webpackChunkName: "demo" */ './views/Withdraw.vue')
        },
        // {
        //   path: '/payment',
        //   name: 'Payment',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Payment.vue')
        // },
        {
          path: '/promotion',
          name: 'promotion',
          component: () => import(/* webpackChunkName: "demo" */ './views/Promotion.vue')
        },
        {
          path: '/setting/:id',
          name: 'washing machine setting',
          component: () => import(/* webpackChunkName: "demo" */ './views/Setting.vue')
        },
        {
          path: '/setting-promotion/:id',
          name: 'setting promotion',
          component: () => import(/* webpackChunkName: "demo" */ './views/SettingPromotion.vue')
        },
        {
          path: '/washing-mode',
          name: 'washing mode',
          component: () => import(/* webpackChunkName: "demo" */ './views/WashingMode.vue')
        },
        {
          path: '/qrcode',
          name: 'generate qrcode',
          component: () => import(/* webpackChunkName: "demo" */ './views/QRCode.vue')
        },
        {
          path: '/statistics/:id',
          name: 'Statistics',
          component: () => import(/* webpackChunkName: "demo" */ './views/Statistics.vue')
        },
        {
          path: '/changepassword2',
          name: 'changepassword2',
          component: () => import(/* webpackChunkName: "demo" */ './views/Changepassword2.vue')
        },

        {
          path: '/reports',
          name: 'reports',
          component: () => import(/* webpackChunkName: "demo" */ './views/Reports.vue')
        }

      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        },
        {
          path: '/remember',
          name: 'remember',
          component: () => import(/* webpackChunkName: "demo" */ './views/Remember.vue')
        },
        {
          path: '/changepassword/:token',
          name: 'changepassword',
          component: () => import(/* webpackChunkName: "demo" */ './views/Changepassword.vue')
        },
        { 
          path: '/changepassword',
          name: 'changepassword_valid',
          redirect: '/login'
          // component: import(/* webpackChunkName: "demo" */ './views/Login.vue')
        } 
      ]
    }
  ]
})
